import styled from 'styled-components';

// WebAwesome.
import WaSkeleton from '@web.awesome.me/webawesome-pro/dist/react/skeleton';

// A circle placeholder matching the real UserAvatar (size 2.5rem).
// NOTE: keep the host on its default (flex) display — wa-skeleton's indicator
// fills the host via flex and collapses to zero height on a block host.
export const Avatar = styled(WaSkeleton)`
  flex-shrink: 0;
  width: 2.5rem;
  height: 2.5rem;

  &::part(indicator) {
    border-radius: 50%;
  }
`;
